import { Box, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { Zap } from 'react-feather';
import { ContentCard } from '../../../../components/common/ContentCard';

/**
 * MED-873 / 2.3c — empty-state AI Insights panel for preview mode.
 *
 * Per AC5 of MED-873: "The AI Insights panel structure renders if the AI
 * Insights toggle is on — the panel is empty in preview as no live nudges
 * are generated."
 *
 * MED-1068 — restyled to consume the shared MED-1012 `ContentCard` base card
 * and match the live MED-1017 AI Insights chrome: purple Zap icon + dark title,
 * a muted "not listening" status row, and a polished empty state. The
 * fully-featured live panel (nudges, prompt selection) is `ActiveSession
 * InsightsPanel`; preview intentionally shows only this empty stub — no live
 * nudges are generated in preview.
 */

const TITLE_COLOR = '#1A1A2E';

export function ActiveSessionAiInsightsPanel() {
  return (
    <ContentCard
      data-testid="active-session-ai-insights-panel"
      header={
        <Group justify="space-between" align="center" wrap="nowrap" w="100%">
          <Group gap={8} align="center" wrap="nowrap" style={{ minWidth: 0 }}>
            <ThemeIcon
              variant="light"
              color="surveyPurple"
              size="sm"
              radius="sm"
            >
              <Zap size={12} />
            </ThemeIcon>
            <Text fz={12} fw={600} c={TITLE_COLOR}>
              AI Insights
            </Text>
          </Group>
          <Group gap={6} align="center" wrap="nowrap">
            <Box
              aria-hidden="true"
              style={{
                width: 6,
                height: 6,
                borderRadius: 3,
                background: 'var(--mantine-color-gray-4)',
              }}
            />
            <Text fz={11} c="dimmed">
              Preview — not listening
            </Text>
          </Group>
        </Group>
      }
    >
      <Stack
        gap={6}
        align="center"
        justify="center"
        style={{ flexGrow: 1, minHeight: 120 }}
      >
        <ThemeIcon variant="light" color="surveyPurple" size={40} radius="xl">
          <Zap size={20} />
        </ThemeIcon>
        <Text size="sm" c="dimmed" ta="center" maw={280}>
          AI insights will appear here once your session is live.
        </Text>
        <Text size="xs" c="dimmed" ta="center" maw={280}>
          No nudges are generated in preview.
        </Text>
      </Stack>
    </ContentCard>
  );
}
